import { render, staticRenderFns } from "./ImgButton.vue?vue&type=template&id=560c5de8&scoped=true"
import script from "./ImgButton.vue?vue&type=script&lang=js"
export * from "./ImgButton.vue?vue&type=script&lang=js"
import style0 from "./ImgButton.vue?vue&type=style&index=0&id=560c5de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c5de8",
  null
  
)

export default component.exports